import UpgradeState from 'components/account-features/UpgradeState';
import React from 'react';

const MemoryUpgradeState: React.FC = () => {
  return <UpgradeState messageKey="memoryRequiresUpgrade" />;
};

export default MemoryUpgradeState;
